import React from "react";
import tikMark from "../../medias/PlantikVector.png";
import { motion } from 'framer-motion';
import AosAnimation from "../../core/AosAnimation";
import { Link } from 'react-router-dom';

const plans = [
  {
    name: "Starter",
    price: "$30",
    period: "/mo",
    features: [
      "Up to 300 Monthly Orders",
      "Amazon Custom and Handmade",
      "Highly Customizable Display",
    ],
  },
  {
    name: "Professional",
    price: "$45",
    period: "/mo",
    features: [
      "Up to 1,000 Monthly Orders",
      "Amazon Custom and Handmade",
      "Highly Customizable Display",
    ],
    badge: "Most Popular",
  },
  {
    name: "Business",
    price: "$60",
    period: "/mo",
    features: [
      "Up to 10,000 Monthly Orders",
      "Preview & User Images On-screen and On Packing Slips",
      "Amazon Custom and Handmade",
      "Highly Customizable Display",
    ],
  },
];

const Plan = () => {
  return (
    <div className="mx-auto max-w-[1120px] px-[24px] sm:px-0 pt-[100px] mb-[220px]" id="pricing">
      <motion.div
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <p className="sm:text-[48px] text-[42px] text-center mb-[64px]">
          Find the <span className="text-[#1387f2]">right plan</span> for your business
        </p>
      </motion.div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {plans.map((plan, index) => (
          <motion.div
            key={plan.name}
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.1 }}
            viewport={{ once: true, amount: 0.2 }}
            className="w-full"
          >
            <div
              className={`mx-auto w-full max-w-sm h-full rounded-[16px] border border-[#BABABA] p-6 shadow-sm bg-white ${
                plan.badge ? "ring-2 ring-[#F29E13] ring-offset-4 shadow-xl" : ""
              }`}
            >
              {plan.badge && (
                <span className="text-[#1387F2] bg-[#E6F3FF] font-bold py-[4px] px-[12px] rounded-[32px] inline-block mb-4">
                  {plan.badge}
                </span>
              )}
              <p className="text-[28px] font-semibold text-gray-900">{plan.name}</p>
              <div className="flex items-end gap-2 my-5">
                <p className="text-[46px] font-bold text-gray-900">{plan.price}</p>
                <p className="text-[#F29E13] text-[28px] font-medium">{plan.period}</p>
              </div>
              <ul className="space-y-4 text-[#7B7B7B] text-[16px]">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-[8px]">
                    <img src={tikMark} alt="" className="mt-1" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a href="https://customsync.app/login?signup=true">
                <button
                  className={`text-[16px] font-bold py-[10px] w-full mt-[24px] border-[1px] rounded-[32px] orange-button ${
                    plan.badge ? "bg-[#F29E13] text-white border-[#F29E13]" : "border-[#F29E13]"
                  }`}
                >
                  Start Trial
                </button>
              </a>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        className="mt-12"
      >
        <div className="mx-auto w-full max-w-xl rounded-[16px] border border-[#BABABA] bg-white p-6 text-center">
          <p className="text-[20px] font-semibold text-[#F29E13]">Enterprise</p>
          <p className="text-[#7B7B7B] text-[16px] mt-3">
            Over 10,000 Monthly Orders or custom fulfillment requirements
          </p>
          <Link to="/contact">
            <button className="text-[16px] font-bold py-[10px] w-[200px] mt-[16px] border-[1px] border-[#F29E13] rounded-[32px] orange-button">
              Contact for Pricing
            </button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Plan;
